module.exports = __webpack_public_path__ + "static/media/icon_6.8ebeb9fb.svg";